import { type ColorPaletteProp } from '@mui/joy';
import { type TabVariant } from './Tabs.types';

const DATA_ATTRIBUTES = {
  VARIANT: 'data-variant',
} as const;

const DEFAULT_CLASSES = {
  TAB: 'rounded-xl border-b border-gray-300 text-xs',
  TAB_LIST: 'inline-flex w-fit flex-wrap gap-2 pb-2 shadow-none',
  TAB_PANEL: 'relative bg-gray-100 p-0',
  TABS: 'w-full rounded-xl bg-gray-100',
} as const;

const VARIANTS = {
  ACTIVE: 'active',
  DEFAULT: 'default',
} as const;

const VARIANTS_MUI_COLORS_MAP = {
  [VARIANTS.ACTIVE]: 'primary',
  [VARIANTS.DEFAULT]: 'neutral',
} as const satisfies { [Variant in TabVariant]: ColorPaletteProp };

export { DATA_ATTRIBUTES, DEFAULT_CLASSES, VARIANTS, VARIANTS_MUI_COLORS_MAP };
